import { render, staticRenderFns } from "./manual-return-sumitomo.vue?vue&type=template&id=173249b5&"
import script from "./manual-return-sumitomo.vue?vue&type=script&lang=js&"
export * from "./manual-return-sumitomo.vue?vue&type=script&lang=js&"
import style0 from "./manual-return-sumitomo.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports